import { cn } from "@/lib/utils/general-utils";

const SIZE_CLASSES = {
  xs: "h-3 w-3",
  sm: "h-4 w-4",
  md: "h-5 w-5",
  lg: "h-6 w-6",
} as const;

interface SpinnerProps {
  readonly size?: keyof typeof SIZE_CLASSES;
  readonly className?: string;
}

export function Spinner({ size = "sm", className }: SpinnerProps) {
  return (
    <svg
      className={cn("animate-spin", SIZE_CLASSES[size], className)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
        fill="none"
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  );
}
